import { Box, Grid, Paper, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import PreviewIcon from '@mui/icons-material/Preview'
import VaccinesIcon from '@mui/icons-material/Vaccines'
import { useNavigate } from 'react-router-dom'
import Person from '@mui/icons-material/Person'
import DoorSlidingIcon from '@mui/icons-material/DoorSliding'
import MinorCrashIcon from '@mui/icons-material/MinorCrash'
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn'
import ColorizeIcon from '@mui/icons-material/Colorize'
import { GlobalContext, TenantSettingsContext } from '../../../../App'
import { hasTierAccess } from '../../../../components/Subscriptions/SubscriptionGate'

const ActionCard = ({ icon: Icon, title, subtitle, tone, onClick }) => (
  <Grid item xs={12} sm={6} lg={4}>
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        borderLeft: `5px solid ${tone}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        transition: 'border-color 0.18s ease, transform 0.18s ease',
        '&:hover': {
          borderColor: `${tone}88`,
          transform: 'translateY(-1px)',
        },
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="center">
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1.5,
            display: 'grid',
            placeItems: 'center',
            color: tone,
            backgroundColor: `${tone}14`,
            flexShrink: 0,
          }}
        >
          <Icon />
        </Box>
        <Stack minWidth={0}>
          <Typography fontWeight={950}>{title}</Typography>
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  </Grid>
)

const Home = ({ setView, bagID }) => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  // Drawn-up medicines are part of the Enterprise Critical Care suite
  const { tenantInfo } = useContext(GlobalContext)
  const canDrawUp = hasTierAccess(tenantInfo, 3)
  const navigate = useNavigate()

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        width: '100%',
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        backgroundColor: '#fff',
      }}
    >
      <Stack spacing={1.5}>
        <Stack spacing={0.25}>
          <Typography fontWeight={950}>Bag actions</Typography>
          <Typography variant="body2" color="text.secondary">
            Choose what you need to do with this medicine bag.
          </Typography>
        </Stack>
        <Box>
          <Grid container spacing={1}>
            <ActionCard
              onClick={() => setView('contents')}
              title="View contents"
              subtitle="Check stock and expiry"
              tone="#1E7F88"
              icon={PreviewIcon}
            />
            {!orgSettings?.patientRecordSettings
              ?.disabledMedicinesAdministrationForm && (
              <ActionCard
                onClick={() =>
                  navigate(
                    `/medicines-management/administration?location=${bagID}`,
                  )
                }
                title="Record administration"
                subtitle="Create a medicine record"
                tone="#16A34A"
                icon={VaccinesIcon}
              />
            )}
            {canDrawUp && (
              <ActionCard
                onClick={() => setView('drawUp')}
                title="Draw up"
                subtitle="Prepare a syringe to carry"
                tone="#D97706"
                icon={ColorizeIcon}
              />
            )}
            <ActionCard
              onClick={() => setView('assignToMe')}
              title="Assign to me"
              subtitle="Check this bag out"
              tone="#9B287B"
              icon={Person}
            />
            {orgSettings?.staffGovernanceSettings
              ?.allowStaffToConductMedsAudit && (
              <ActionCard
                onClick={() =>
                  navigate(`/medicines-management/record-audit/${bagID}`)
                }
                title="Conduct audit"
                subtitle="Complete a bag audit"
                tone="#2563EB"
                icon={AssignmentTurnedIn}
              />
            )}
            <ActionCard
              onClick={() => setView('assignToVehicle')}
              title="Assign to vehicle"
              subtitle="Move bag onto a vehicle"
              tone="#0891B2"
              icon={MinorCrashIcon}
            />
            <ActionCard
              onClick={() => setView('returnToStores')}
              title="Return to stores"
              subtitle="Move bag back to store"
              tone="#242F40"
              icon={DoorSlidingIcon}
            />
          </Grid>
        </Box>
      </Stack>
    </Paper>
  )
}

export default Home
